module.exports = {
    ToggleButtonGroupComponentDefinition: {
        template: require('./toggle-button-group.component.html').trim(),
        transclude: true,
        bindings: {
            groupClass: '@?',
        },
    },
};



// WEBPACK FOOTER //
// ./src/common/togglebuttongroup/toggle-button-group.component.js